import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Button } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { ROUTE_PATHS } from 'common/routePaths'

type TotalReimbursementRequestProps = {
  totalReimbursementRequests: number
  planPeriodId: string
  startDate: string
}

const TotalReimbursementRequest = ({
  totalReimbursementRequests,
  planPeriodId,
  startDate,
}: TotalReimbursementRequestProps) => {
  const { t: translate } = useTranslation()
  const history = useHistory()

  return (
    <>
      <div className="flex flex_space_between outer-div">
        <div className="color-gray-8 pt-4">
          {totalReimbursementRequests > 1 ? (
            <span className="color-gray-9 text-semi-bold">{totalReimbursementRequests} Reimbursement Requests </span>
          ) : (
            <span className="color-gray-9 text-semi-bold">{totalReimbursementRequests} Reimbursement Request </span>
          )}
          {translate('admin-dashboard.home.perks-welcome.waiting-approval')} for{' '}
          <span className={'color-gray-9 text-semi-bold'}>{parseZoneFormat(startDate) + ' - Continuous'}</span>
        </div>
        <Button
          className="c-white"
          type="primary"
          onClick={() =>
            history.push(
              `${ROUTE_PATHS.REIMBURSEMENTS}?tabActiveKey=expense-approvals-due&planPeriodId=${planPeriodId}`,
            )
          }
        >
          Approve now
        </Button>
      </div>
    </>
  )
}

export default TotalReimbursementRequest
